import { getOs, getBrowser, post, upload, get, base64Encode } from '@chat/utils';
import { Dispatch } from 'redux';
import { UploadVideo } from '@chat/components/src/UploadVideo/type';
import {
    IM_CLOSE,
    IM_COMMENT,
    IM_EVALUATE,
    IM_INIT,
    IM_SAVE_CONTACE,
    IM_SELECT,
    IM_SEND,
    START,
    SYSTYEM_TIME
} from '@/api/url';

import { MSGTYPE } from '@/config/enum';
import { ImState, MyThunkResult } from '@/typings/reducer';
import { IM_LOCAL_VIDEO_FILE, IM_MESSAGE, IM_USER_CONTACT } from '@/typings/global';
import { PAYLOAD_LAST, PAYLOAD_NOTICE, PAYLOAD_STATUS, PAYLOAD_WAKEUP } from '@/typings/payload';
import { PARAM_EVALUATE, PARAM_SEND, PARAM_COMMENT } from '@/typings/params';
import { buildInitMsgList, withMessageTime } from '@/helpers/imContext';
import {
    IMReloadImAction,
    IMResendMessageAction,
    IMSetChatStatusAction,
    IMSetLastAction,
    IMSetMessageAction,
    IMSetMessageCountAction,
    IMSetNavVisibleAction,
    IMSetNoticeAction,
    IMSetSessionAction,
    IMSetStageStatusAction,
    IMSetStartSessionAction,
    IMSetVideoLockStateAction,
    IMSetVideoMessageUuidStateAction,
    IMSetVideoParamStateAction,
    IMSetVideoTempListStateAction,
    IMSetUserContactStateAction,
    IMSetWakeUpAction,
    IM_TYPE
} from './actionType';
import { TIME_OUT } from '@/config/config';
import { INDEX_TYPE } from '../index/actionType';

/**
 * 插入人工消息
 * @param {*} msg
 */
export const imappend =
    (msg: IM_MESSAGE): MyThunkResult<unknown, IMSetMessageAction> =>
    (dispatch: Dispatch<IMSetMessageAction>, getState) => {
        const { type, __id } = msg;
        const { message_list } = getState().IMReducer;
        const uniq = _.find(message_list, { __id: `MSG-${MSGTYPE.WAITING_QUEUE}-${__id}` });
        // 相同会话的排队人数不重复触发flicker
        if (type === MSGTYPE.WAITING_QUEUE) {
            if (_.isEmpty(uniq)) {
                IM.flickerStart();
            }
        } else {
            IM.flickerStart();
        }
        dispatch({
            type: IM_TYPE.SET_MESSAGE_LIST,
            payload: withMessageTime(msg)
        });
    };
/**
 * 插入系统通知
 * @param {*} type
 * @param {*} message
 */
export const imnotice =
    (
        type: PAYLOAD_NOTICE['type'],
        message: PAYLOAD_NOTICE['message']
    ): MyThunkResult<unknown, IMSetNoticeAction> =>
    (dispatch: Dispatch<IMSetNoticeAction>) => {
        dispatch({
            type: IM_TYPE.SET_NOTICE_LIST,
            payload: { type, message }
        });
    };
/**
 * mq计数
 */
export const setCount =
    (): MyThunkResult<unknown, IMSetMessageCountAction> =>
    (dispatch: Dispatch<IMSetMessageCountAction>) => {
        dispatch({
            type: IM_TYPE.SET_MESSAGE_COUNT
        });
    };
/**
 * 设置消息id，time及超时提醒
 * @param {*} last_id 最后一条消息id
 * @param {*} last_time 最后一条消息时间
 */
export const setLast =
    ({ last_id, last_time }: PAYLOAD_LAST): MyThunkResult<unknown, IMSetLastAction> =>
    (dispatch: Dispatch<IMSetLastAction>) => {
        dispatch({
            type: IM_TYPE.SET_LAST,
            payload: { last_id, last_time }
        });
    };
export const setLastTime =
    ({
        now,
        last_time,
        compare
    }: {
        now?: string;
        last_time?: any;
        compare?: 'immidiate' | 'delay';
    }): MyThunkResult<unknown, IMSetLastAction> =>
    async (dispatch: Dispatch<IMSetLastAction>): Promise<string> => {
        let NOW = now;
        if (!now) {
            try {
                const res = await get(SYSTYEM_TIME);
                NOW = dayjs.unix(res.data.d.time).format('YYYY-MM-DD HH:mm:ss');
            } catch (error) {
                console.warn('获取系统时间失败:', error);
            }
        }
        if (NOW) {
            dispatch({
                type: IM_TYPE.SET_LAST,
                payload: { last_time: NOW }
            });
            const shouldNotify =
                compare === 'immidiate' ||
                (compare === 'delay' && dayjs(NOW).diff(last_time, 'milliseconds') > TIME_OUT);
            if (shouldNotify) {
                IM.IMServer.notice('warn', NOW);
            }
            return NOW;
        }
        return '';
    };
/**
 * 激活界面动作
 * @param {*} actived 是否能够操作界面
 * @param {*} started 用户是否被分配客服
 */
export const imwakeup =
    ({ actived = 0, started = 0 }: PAYLOAD_WAKEUP): MyThunkResult<unknown, IMSetWakeUpAction> =>
    (dispatch: Dispatch<IMSetWakeUpAction>, getState) => {
        dispatch({
            type: IM_TYPE.SET_WAKEUP_CHAT,
            payload: {
                actived,
                started
            }
        });
    };
/**
 * 设置人工阶段各状态
 * @param {*} name 阶段名
 * @param {*} value 阶段状态
 */
export const setchatstatus =
    ({ name, value }: PAYLOAD_STATUS): MyThunkResult<unknown, IMSetChatStatusAction> =>
    (dispatch: Dispatch<IMSetChatStatusAction>) => {
        dispatch({
            type: IM_TYPE.SET_CHAT_STATUS,
            payload: { name, value }
        });
    };
/**
 * 重新发送消息
 * @param {*} key 发送成功移除old消息
 */
export const resendmessage =
    (key: string): MyThunkResult<unknown, IMResendMessageAction> =>
    (dispatch: Dispatch<IMResendMessageAction>) => {
        dispatch({
            type: IM_TYPE.RESEND_MESSAGE,
            payload: key
        });
    };
/**
 * 重制会话相关内容
 */
export const reloadim =
    (): MyThunkResult<unknown, IMReloadImAction> => (dispatch: Dispatch<IMReloadImAction>) => {
        dispatch({
            type: IM_TYPE.RELOAD_IM
        });
    };
/**
 * 设置阶段状态
 * @param {*} int 0:faq 1:排队 2:人工
 */
export const setstage =
    (int: ImState['stage']): MyThunkResult<unknown, IMSetStageStatusAction> =>
    (dispatch: Dispatch<IMSetStageStatusAction>) => {
        dispatch({
            type: IM_TYPE.SET_STAGE_STATUS,
            payload: int
        });
    };
/**
 * 是否显示/隐藏导航条
 * @param {*} int
 */
export const setvisiblenav =
    (int: number): MyThunkResult<unknown, IMSetNavVisibleAction> =>
    (dispatch: Dispatch<IMSetNavVisibleAction>) => {
        dispatch({
            type: IM_TYPE.SET_NAV_VISIBLE,
            payload: int
        });
    };
/**
 * 人工初始化
 * @param {*} data
 */
export const init =
    (isStart: boolean): MyThunkResult<unknown, IMSetSessionAction | IMSetStartSessionAction> =>
    async (
        dispatch: Dispatch<IMSetSessionAction | IMSetStartSessionAction>,
        getState
    ): Promise<ImState> => {
        try {
            const {
                base_config: { game, welcome, faq_switch, faq_unique_id }
            } = getState().IndexReducer;
            const { prefix, message_list } = getState().IMReducer;
            const res = await post(IM_INIT(isStart ? prefix : `${game.key}/`), {
                game: game.id,
                platform: game.platform,
                faq_unique_id,
                os: getOs(),
                browser: getBrowser(),
                msg_list: JSON.stringify(buildInitMsgList(message_list))
            });
            const {
                d: { messages, start }
            } = res.data;
            const message = start.message || [];
            if (isStart) {
                dispatch({
                    type: IM_TYPE.SET_START_SESSION,
                    payload: { auto_start: start.auto_start }
                });
                IM.IMServer.lists(message);
            } else {
                const NOW = await setLastTime({ compare: faq_switch !== 1 ? 'immidiate' : null })(
                    dispatch
                );
                dispatch({
                    type: IM_TYPE.SET_SESSION,
                    payload: { ...res.data.d, prefix: `${game.key}/${res.data.d.sess_id}/` }
                });
                const _list =
                    faq_switch !== 1 && welcome
                        ? [
                              {
                                  id: 0,
                                  message: welcome.message,
                                  type: 'in',
                                  __t: null,
                                  time: NOW
                              },
                              ...(messages || [])
                          ]
                        : messages || [];
                IM.IMServer.lists([..._list, ...message]);
            }
            return await Promise.resolve(res.data.d);
        } catch (err) {
            IM.IMServer.notice('error', err?.data?.e || err);
            return Promise.reject(err);
        }
    };
/**
 *
 * @param data
 * @returns
 */
export const saveContact =
    (data): MyThunkResult<unknown, unknown> =>
    (dispatch, getState) =>
        new Promise((resolve, reject) => {
            const { prefix } = getState().IMReducer;
            post(IM_SAVE_CONTACE(prefix), data)
                .then((res) => {
                    const _data = _.entries(data)[0];
                    dispatch({
                        type: INDEX_TYPE.SET_CONTACT,
                        payload: { field: _data[0], txt: _data[1] }
                    });
                    dispatch({
                        type: IM_TYPE.SET_USER_CONTACT,
                        payload: { key: _data[0], value: _data[1] }
                    });
                    return resolve(res.data.d);
                })
                .catch((err) => reject(err));
        });
/**
 * 开启人工分配
 */
// export const start =
//     (): MyThunkResult<unknown, IMSetStartSessionAction> =>
//     (dispatch: Dispatch<IMSetStartSessionAction>, getState) =>
//         new Promise<ImState>((resolve, reject) => {
//             const { prefix } = getState().IMReducer;
//             const {
//                 base_config: { faq_unique_id }
//             } = getState().IndexReducer;
//             const data = {
//                 // 初始会话有faq需要传递该id
//                 ...(+faq_unique_id !== 0 && { faq_unique_id })
//             };
//             post(START(prefix), data)
//                 .then((res) => {
//                     const {
//                         d: { message, auto_start }
//                     } = res.data;
//                     dispatch({
//                         type: IM_TYPE.SET_START_SESSION,
//                         payload: { auto_start }
//                     });
//                     IM.IMServer.lists(message);
//                     return resolve(res.data.d);
//                 })
//                 .catch((err) => {
//                     IM.IMServer.notice('error', err?.data?.e || err);
//                     return reject(err);
//                 });
//         });
/**
 * 评价
 * @param {*} data
 */
export const setevaluate =
    (data: PARAM_EVALUATE): MyThunkResult<unknown, unknown> =>
    (dispatch, getState) =>
        new Promise((resolve, reject) => {
            const { prefix } = getState().IMReducer;
            post(IM_EVALUATE(prefix), data)
                .then((res) => resolve(res.data.d))
                .catch((err) => {
                    IM.IMServer.notice('error', err?.data?.e || err);
                    return reject(err);
                });
        });
/**
 * 结束会话
 * @param {*} quit
 */
export const closechat =
    (quit = 0): MyThunkResult<unknown, unknown> =>
    (dispatch, getState) =>
        new Promise((resolve, reject) => {
            const { prefix } = getState().IMReducer;
            let data = {};
            data = { ...data, act: quit };
            post(IM_CLOSE(prefix), data)
                .then((res) => resolve(res.data.d))
                .catch((err) => {
                    IM.IMServer.notice('error', err?.data?.e || err);
                    return reject(err);
                });
        });
/**
 * 发送人工阶段消息
 * @param {*} m
 */
export const imsend =
    ({ m, type }: PARAM_SEND): MyThunkResult<unknown, unknown> =>
    (dispatch, getState) =>
        new Promise((resolve, reject) => {
            const { prefix } = getState().IMReducer;
            const { last_id, started } = getState().IMReducer;

            const data = {
                m,
                l: last_id,
                ...(type && { c: type }),
                ...(started !== 1 && { s: 1 })
            };
            const func = {
                upload: () => {
                    const formData = new FormData();
                    Object.entries(data).forEach(([key, value]) => {
                        formData.append(key, value);
                    });
                    return upload(IM_SEND(prefix), formData);
                },
                post: () => {
                    return post(IM_SEND(prefix), data);
                }
            };
            (type === 'upload_image' ? func.upload : func.post)()
                .then((res) => {
                    const {
                        d: { message = [], type: __t = '' }
                    } = res.data;
                    // 这里可能会产生无key的消息通知
                    if (message.length > 0) {
                        IM.IMServer.notice(message[0], message[1]);
                    }
                    if (type) {
                        IM.IMServer.noticeSwitch(__t);
                    }
                    if (started !== 1) {
                        imwakeup({ actived: 1, started: 1 })(dispatch, getState);
                        IM.IMServer.loop();
                    }
                    return resolve(res.data.d);
                })
                .catch((err) => {
                    IM.IMServer.notice('error', err?.data?.e || err);
                    return reject(err);
                });
        });

/**
 * 手动选择客服
 * @param {*} gm
 */
export const selectgm =
    (gm = 'auto'): MyThunkResult<unknown, unknown> =>
    (dispatch, getState) =>
        new Promise((resolve, reject) => {
            const { prefix } = getState().IMReducer;
            post(IM_SELECT(prefix), { gm })
                .then((res) => {
                    if (res.data.d === 'FAIL') {
                        return;
                    }
                    if (res.data.d !== 'OK') {
                        if (gm !== 'auto') {
                            // dispatch(setstage(2));
                        }
                        // IM.IMServer.lists(res);
                        IM.IMServer.loop();
                    }
                    return resolve(res.data.d);
                })
                .catch((err) => {
                    IM.IMServer.notice('error', err?.data?.e || err);
                    return reject(err);
                });
        });

/**
 * 设置锁定状态
 * @param {*} name 按钮
 * @param {*} value 按钮状态
 */
export const setlocked =
    ({ name, value }): MyThunkResult<unknown, unknown> =>
    (dispatch) => {
        dispatch({
            type: IM_TYPE.SET_LOCK_STATUS,
            payload: { name, value }
        });
    };
/**
 * 视频上传锁
 * @param {*} lock
 */
export const setVideoLock =
    (lock: boolean): MyThunkResult<unknown, IMSetVideoLockStateAction> =>
    (dispatch: Dispatch<IMSetVideoLockStateAction>) => {
        dispatch({
            type: IM_TYPE.SET_VIDEO_LOCK,
            payload: lock
        });
    };

/**
 * 留言
 * @param {*} data
 */
export const setcomment =
    (data: Partial<PARAM_COMMENT>): MyThunkResult<unknown, unknown> =>
    (dispatch, getState) =>
        new Promise((resolve, reject) => {
            const { prefix } = getState().IMReducer;
            post(IM_COMMENT(prefix), data)
                .then((res) => resolve(res.d))
                .catch((err) => reject(err));
        });
/**
 * 编辑小表单
 */
export const editCollect =
    ({ collect_type, fields }: any): MyThunkResult<unknown, unknown> =>
    (dispatch, getState) =>
        new Promise((resolve, reject) => {
            const { prefix } = getState().IMReducer;
            const data = {
                m: [collect_type, base64Encode(JSON.stringify(fields))].join(';'),
                c: 'collect_edit'
            };
            post(IM_SEND(prefix), data)
                .then((res) => {
                    return resolve(res.data.d);
                })
                .catch((err) => reject(err));
        });
/**
 * 视频对象
 * @param {*}
 */
export const setVideoParam =
    (param: UploadVideo): MyThunkResult<unknown, IMSetVideoParamStateAction> =>
    (dispatch: Dispatch<IMSetVideoParamStateAction>) => {
        dispatch({
            type: IM_TYPE.SET_VIDEO_PARAM,
            payload: param
        });
    };

/**
 * 缓存视频到临时列表
 * @param {*} uuid
 */
export const pushVideoToTempList =
    (uuid: string): MyThunkResult<unknown, IMSetVideoTempListStateAction> =>
    (dispatch: Dispatch<IMSetVideoTempListStateAction>) => {
        dispatch({
            type: IM_TYPE.SET_VIDEO_TEMP_LIST,
            payload: uuid
        });
    };

/**
 * 同步本地视频消息uuid
 * @param {*} file
 * @param {*} uuid
 */
export const setVideoMessageUuid =
    (
        file: IM_LOCAL_VIDEO_FILE,
        uuid: string
    ): MyThunkResult<unknown, IMSetVideoMessageUuidStateAction> =>
    (dispatch: Dispatch<IMSetVideoMessageUuidStateAction>) => {
        dispatch({
            type: IM_TYPE.SET_VIDEO_MESSAGE_UUID,
            payload: { file, uuid }
        });
    };

/**
 * 设置用户联系方式
 * @param {*} contact
 */
export const setUserContact =
    (contact: IM_USER_CONTACT): MyThunkResult<unknown, IMSetUserContactStateAction> =>
    (dispatch: Dispatch<IMSetUserContactStateAction>) => {
        dispatch({
            type: IM_TYPE.SET_USER_CONTACT,
            payload: contact
        });
    };
